import React from "react";
import "./styles/PricingPage.css";
import { Link } from "react-router-dom";

const PricingPage = () => {
  return (
    <div className="pricing-page">
      <h1 className="pricing-title">Storm response runs for local service operators</h1>
      <p className="pricing-subtitle">One paid run produces the response kit and customer-facing status page for a selected ZIP and service type.</p>

      <div className="pricing-cards">
        <div className="card recommended">
          <div className="badge">Production run</div>
          <h2>StormOps Dispatch Run</h2>
          <p className="price">£49<span>/run</span></p>
          <ul className="feature-list">
            <li>Official alert preview for one U.S. ZIP code</li>
            <li>Response kit based on the selected service type</li>
            <li>Customer notice and operations checklist</li>
            <li>Public status page after paid production</li>
            <li>Durable history for reopening completed runs</li>
          </ul>
          <Link to="/" className="button-primary">Build Preview</Link>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
